import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { useQuery } from '@tanstack/react-query'
import FileDelimitedIcon from 'mdi-react/FileDelimitedIcon'
import MicrosoftExcelIcon from 'mdi-react/MicrosoftExcelIcon'
import { twJoin } from 'tailwind-merge'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import { useIsThreeStepIT } from '@/hooks/access'
import queries from '@/modules/admin/queries'

import { exportDataToExcel } from '../../helpers'
import type { ReportFilters } from '../../resources'
import adminResources from '../../resources'

export const OffBoardingOptions: FC<{
  title: string
  filters: ReportFilters
}> = ({ title, filters }) => {
  const translate = useTranslation()
  const isThreeStepIT = useIsThreeStepIT()

  const { data: reports } = useQuery(queries.adminOffboardingReports(filters), () =>
    adminResources.getOffboardingReports(filters)
  )

  if (!reports) throw Error('We have encountered a problem while loading reports')

  const reportsData = reports.map(report => ({
    customerName: report.customerName,
    userName: report.userName,
    employeeNo: report.employeeNo,
    assetStatus: report.assetStatus,
    terminationStatus: report.terminationStatus,
  }))

  const columnFormats = {}

  return (
    <div className="grid grid-cols-2">
      <Button
        Icon={<MicrosoftExcelIcon className={twJoin(!isThreeStepIT && 'text-emerald-600')} />}
        className="mb-4 ml-0"
        onClick={() =>
          exportDataToExcel(reportsData, title, {
            translate,
            columnFormats,
            fromDate: filters.fromDate,
            toDate: filters.toDate,
          })
        }
      >
        <Translation id="Excel" />
      </Button>
      <Button
        Icon={<FileDelimitedIcon className={twJoin(!isThreeStepIT && 'text-emerald-600')} />}
        className="mb-4 ml-0"
        onClick={() =>
          exportDataToExcel(reportsData, title, {
            translate,
            columnFormats,
            extension: 'csv',
            fromDate: filters.fromDate,
            toDate: filters.toDate,
          })
        }
      >
        <Translation id="CSV" />
      </Button>
    </div>
  )
}
